import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { cn } from '@/lib/utils'

interface BrandLogoProps {
    /** dark: dark text for light surfaces, light: white text for dark surfaces */
    tone?: 'dark' | 'light'
    className?: string
}

export const BrandLogo: FC<BrandLogoProps> = ({ tone = 'dark', className }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-3', className)}>
            <span className='relative size-10 shrink-0 overflow-hidden rounded-full bg-white shadow-sm ring-1 ring-black/5'>
                <Image
                    src='/images/logo-mark.png'
                    alt=''
                    fill
                    sizes='40px'
                    className='object-cover'
                />
            </span>

            <span className='flex flex-col leading-none'>
                <span className={cn('text-base font-extrabold tracking-tight', tone === 'dark' ? 'text-ink' : 'text-white')}>
                    Sehat Budi Luhur
                </span>

                <span className={cn('mt-1 text-[10.5px] font-bold tracking-[0.2em] uppercase', tone === 'dark' ? 'text-brand-700' : 'text-brand-200')}>
                    Klinik Pratama
                </span>
            </span>
        </span>
    )
}
